export default __webpack_public_path__ + "static/media/jahorina-wall.9aeabab3.jpg";